import Dexie, { type Table } from 'dexie'
import type {
  CollectionItem,
  Deck,
  DeckCard,
  ScanIssueReport,
  SyncStateRecord,
} from './types'

class CardVaultDatabase extends Dexie {
  collection!: Table<CollectionItem, number>
  decks!: Table<Deck, number>
  deckCards!: Table<DeckCard, number>
  scanIssueReports!: Table<ScanIssueReport, number>
  syncState!: Table<SyncStateRecord, string>

  constructor() {
    super('card-vault')
    this.version(1).stores({
      collection:
        '++id, game, name, setName, setCode, collectorNumber, rarity, addedAt, lastPriceCheck',
    })
    this.version(2).stores({
      collection:
        '++id, game, name, setName, setCode, collectorNumber, rarity, addedAt, lastPriceCheck',
      decks: '++id, game, name, createdAt, updatedAt',
      deckCards: '++id, deckId, collectionItemId, [deckId+collectionItemId], addedAt',
    })
    this.version(3).stores({
      collection:
        '++id, game, name, setName, setCode, collectorNumber, rarity, addedAt, lastPriceCheck',
      decks: '++id, game, name, createdAt, updatedAt',
      deckCards: '++id, deckId, collectionItemId, [deckId+collectionItemId], addedAt',
      scanIssueReports: '++id, game, correctName, createdAt',
    })
    this.version(4).stores({
      collection:
        '++id, &syncId, game, name, setName, setCode, collectorNumber, rarity, addedAt, lastPriceCheck',
      decks: '++id, &syncId, game, name, createdAt, updatedAt',
      deckCards:
        '++id, &syncId, deckId, collectionItemId, [deckId+collectionItemId], addedAt',
      scanIssueReports: '++id, game, correctName, createdAt',
      syncState: '&id, profileId',
    })
    this.version(5).stores({
      collection:
        '++id, &syncId, game, listKind, name, sport, manufacturer, releaseYear, setName, setCode, collectorNumber, gradingCompany, grade, sportsPriceStatus, addedAt, lastPriceCheck',
      decks: '++id, &syncId, game, name, createdAt, updatedAt',
      deckCards:
        '++id, &syncId, deckId, collectionItemId, [deckId+collectionItemId], addedAt',
      scanIssueReports: '++id, game, correctName, createdAt',
      syncState: '&id, profileId',
    })
  }
}

export const db = new CardVaultDatabase()
